import React, { createContext, useState } from 'react'

interface Context {
	setUser: (user:Object) => void,
	user: Object
}

export const UserContext = createContext<Context>({
	setUser: () => { },
	user: {},
})

export const UserProvider:React.FC<React.ReactNode> = ({ children }) => {
	const [user, setUser] = useState<Object>({})

	return (
		<UserContext.Provider value={{ user, setUser }}>
			{children}
		</UserContext.Provider>
	)
}
